import * as yup from 'yup';
import { IBaseEntity, IMeal, MealSchema } from '../../../common';

export const LiquidOutputSchema = yup.object({
  amount: yup.number().required(),
  date: yup.date().required(),
});

export interface ILiquidOutput extends Partial<IBaseEntity> {
  amount: number;
  date: Date;
}

export const UpdateLiquidOutputSchema = yup.object({
  id: yup.string().required(),
  amount: yup.number().notRequired(),
  date: yup.date().notRequired(),
});

export interface IUpdateLiquidOutput {
  id: string;
  amount?: number;
  date?: Date;
}

export const NutritionProtocolFormSchema = yup.object({
  residentId: yup.string().required(),
  date: yup.date().required(),
  meals: yup.array(MealSchema).optional().default([]),
  liquidOutputs: yup.array(LiquidOutputSchema).optional().default([]),
});

export interface INutritionProtocol {
  residentId: string;
  date: Date;
  meals?: IMeal[];
  liquidOutputs?: ILiquidOutput[];
}

export const UpdateNutritionProtocolFormSchema = yup.object({
  id: yup.string().required(),
  residentId: yup.string().required(),
  date: yup.date().notRequired().optional(),
  meals: yup.array(MealSchema).optional().default([]),
  liquidOutputs: yup.array(LiquidOutputSchema).optional().default([]),
});

export interface IUpdateNutritionProtocol {
  id: string;
  residentId: string;
  date?: Date;
  meals?: IMeal[];
  liquidOutputs?: ILiquidOutput[];
}
